import React, { Component } from "react";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";
import MenuItem from "@material-ui/core/MenuItem";

export default class CustomizedSelect extends Component {
  render() {
    return (
      <div
        style={{
          width: this.props.emailStyle
            ? "30%"
            :this.props.nomineeStyle
            ? "50%"
            : !!this.props.fatcawidth
            ? "80%"
            : "100%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="input-name">{this.props.name}{" "} {this.props.required && (<span style={{color:"red"}}>*</span>)}</div>
          {this.props.uptext && (
            <div
              className="input-name"
              style={{
                fontFamily: "OpenSans-SemiBold",
                fontSize: 15,
                marginLeft: 10,
                color: "red",
              }}
            >
              {this.props.uptext}
            </div>
          )}
        </div>
        <Select
          value={this.props.value}
          onChange={this.props.handleChange}
          displayEmpty
          disabled={this.props.disabled}
          inputRef={this.props.inputRef}
          onBlur={this.props.onBlur}
          input={
            <InputBase
              name={this.props.name}
              id={this.props.id}
              style={{
                border: "1px solid lightgray",
                borderColor: this.props.isError
                  ? "red"
                  : this.props.borderColor
                  ? this.props.borderColor
                  : "lightgray",
                borderRadius: 5,
                width: "100%",
                padding: "7px 15px",
                margin: "0px 0px 0px",
                whiteSpace: "pre-wrap",
              }}
            />
          }
        >
          {!!this.props.placeholder && (
            <MenuItem value="" disabled style={{ whiteSpace: "pre-wrap" }}>
              {this.props.placeholder}
            </MenuItem>
          )}
          {this.props.children}
        </Select>
        {!!this.props.isError && (
          <div
            className="input-name"
            style={{ color: "red", fontFamily: "OpenSans-Italic" }}
          >
            {this.props.errorMessage}
          </div>
        )}
      </div>
    );
  }
}
